import { Component, Optional, Inject } from '@angular/core';
import { BaseComponent } from '../../../../shared/base-components/base.component';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MotorCarrierFleetVehicleService } from '../../../services/motor-carrier-vehicle.service';
import { first } from 'rxjs/operators';
import { MotorCarrierAccountTPAFeeSummary } from '../../../models/motor-carrier-account-fleet/motor-carrier-account-tpa-fee-summary.model';

export class MotorCarrierAccountTPAFeeSummaryModalData {
    constructor(
        public permitNumber: string
    ) { }
}

@Component({
    selector: 'motor-carrier-account-tpa-fee-summary-modal',
    templateUrl: './motor-carrier-account-tpa-fee-summary-modal.html'
})

export class MotorCarrierAccountTPAFeeSummaryModalComponent extends BaseComponent {
    public feeSummaryModel: MotorCarrierAccountTPAFeeSummary[];

    public feeAmountTotal: number;

    public dataLoaded = false;

    constructor(public dialogRef: MatDialogRef<MotorCarrierAccountTPAFeeSummaryModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: MotorCarrierAccountTPAFeeSummaryModalData,
        public motorCarrierFleetVehicleService: MotorCarrierFleetVehicleService) {
        super();
    }

    async ngOnInit() {
        let result = await this.motorCarrierFleetVehicleService.getMotorCarrierAccountTpaFeeSummary(this.data.permitNumber).pipe(first()).toPromise();
        this.feeSummaryModel = result.result;
        this.feeAmountTotal = this.feeSummaryModel.reduce((agg, current) => agg + current.feeAmount, 0);
        this.dataLoaded = true;
    }

    /**
     * Closes the dialogRef
     * */
    cancel() {
        this.dialogRef.close();
    }
}
